<template>
  <el-card class="box-card" style="margin: 30px;">
    <el-container>
      <div style="display: flex; width: 100%;">
        <div style="width: 420px;height:860px;box-shadow:5px 5px 2px #000 inset,5px 5px 10px #666; border-radius: 30px; border: 12px solid #000;">
          <div style="width:101%;height: 40px; background-color: #000; display: flex; align-items: center; justify-content: center;">
            <span style="color: #fff;">手机模拟</span>
          </div>
          <div style="padding: 10px;">
            <el-carousel height="240px" indicator-position="outside">
              <el-carousel-item v-for="item in lbtdata" :key="item">
                <div v-if="item.urltype === 1" style="height:100%; width:100%;">
                  <el-image
                    :src="item.img_url"
                    style="height:100%; width:100%;"
                    fit="cover"></el-image>
                </div>
                <div v-if="item.urltype === 2" style="height:100%; width:100%;">
                  <video :src="item.img_url" controls style="height:100%; width:100%;"></video>
                </div>
              </el-carousel-item>
            </el-carousel>
            <el-collapse v-model="activeNames" style="width:386px;max-height:520px;overflow-y:auto;">
              <el-collapse-item title="基础信息" name="1">
                <div style="color: #000; padding: 15px;height:100px">
                  <div>
                    产品名称：{{newgoods.name}}
                  </div>
                  <div style="margin-top: 10px; color: darkred">
                    价格：
                    <span style="font-size: 18px;"> {{newgoods.baseprice}} </span>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="属性信息" name="2">
                <div style="flex: 1;">
                  <div style="margin: 10px 0 0 20px; color: darkred">
                    <div v-for="(item,index) in edattrs" :key="index" style="margin-bottom: 10px;">
                      <div>{{item.attrname}}: <span style="margin-left: 10px; color: #8a8a8a">{{item.attrvalue}}</span></div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="规格信息" name="3">
                <div style="margin: 10px 0 0 0px; color: darkred; display: flex; flex-flow: row wrap; width: 100%;">
                  <el-button style="margin: 10px 0 0 10px;" type="info" plain disabled v-for="(item,index) in edspec" :key="index">{{item.attrname}}</el-button>
                </div>
              </el-collapse-item>
              <el-collapse-item title="产品描述" name="4">
                <div style="padding: 10px;height:120px;">
                  <span v-html="pagecontext"></span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div style="flex: 1;margin: 0 20px 0 20px;">
          <el-card class="box-card">
            <div slot="header" style="height: 40px; display: flex; align-items: center; justify-content: space-between;">
              <span>产品信息</span>
              <el-button size="small" type="success" icon="el-icon-plus" @click="addnewgoods">增加新品</el-button>
            </div>
            <div>
              <el-tabs v-model="activeName1" type="card">
                <el-tab-pane label="基础商品" name="bgoods">
                  <GoodsBase ref="goodsbase" @nextattr="nextattr" @reloaddata="reloaddata"></GoodsBase>
                </el-tab-pane>
                <el-tab-pane v-if="!if_newgoods" label="商品属性" name="gattr">
                  <MAttrs @reloaddata="reloaddata" @prebaseinfo="prebaseinfo" :curgoodsid="curgoodsid" :hidden="ma_hidden"></MAttrs>
                </el-tab-pane>
                <el-tab-pane v-if="!if_newgoods" label="商品规格" name="gspec">
                  <MSpecs @reloaddata="reloaddata" @preattr="preattr"></MSpecs>
                </el-tab-pane>
                <el-tab-pane v-if="!if_newgoods" label="商品图片" name="gimgs">
                  <GImg @reloaddata="reloaddata" @preaspec="preaspec" @nextdes="nextdes"></GImg>
                </el-tab-pane>
                <el-tab-pane v-if="!if_newgoods" label="商品描述" name="gdes">
                  <GDes @reloaddata="reloaddata" @preaimg="preaimg" @completegoods="completegoods"></GDes>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
      </div>
    </el-container>
  </el-card>
</template>

<script>
  import GoodsBase from './GoodsBase'
  import MAttrs from './MAttrs'
  import MSpecs from './MSpecs'
  import GImg from './GImg'
  import GDes from './GDes'
  var that
  export default {
    name: 'NewGoods',
    components: {
      GDes,
      MSpecs,
      GoodsBase,
      MAttrs,
      GImg
    },
    data () {
      return {
        lbtdata: [],
        activeName1: 'bgoods',
        activeNames: ['1','2','3','4'],
        edattrs: [],
        edspec: [],
        newgoods: '',
        pagecontext: '',
        activestep: 1,
        gb_hidden: true,
        ma_hidden: true,
        ms_hidden: true,
        img_hidden: true,
        des_hidden: true,
        if_newgoods: true,
        curgoodsid: -1
      }
    },
    created: function () {
      that = this
      if (localStorage.getItem('curstep') && localStorage.getItem('curstep') < 6) {
        that.activestep = parseInt(localStorage.getItem('curstep'))
      } else {
        that.activestep = 1
        localStorage.setItem('curgoodsid', -1)
      }
      window.console.log(that)
      // localStorage.setItem('curgoodsid', -1)
      switch (that.activestep) {
        case 1:
          that.gb_hidden = false
          break;
        case 2:
          that.ma_hidden = false
          break;
        case 3:
          that.ms_hidden = false
          break;
        case 4:
          that.img_hidden = false
          break;
        case 5:
          that.des_hidden = false
          break;
      }
      that.reloaddata()
    },
    methods: {
      getlbtlist () {
        var qstr = {
          whereinfo: 'pos=1 and goods_id = ' + localStorage.getItem('curgoodsid') + " and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygimgs',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.lbtdata = res.data
            } else {
              that.lbtdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addnewgoods () {
        that.if_newgoods = true
        localStorage.setItem('curgoodsid', -1)
        that.$refs.goodsbase.initdata()
        that.activeName1 = 'bgoods'
        that.reloaddata()
      },
      reloaddata () {
        if (localStorage.getItem('curgoodsid') !== '-1') {
          this.if_newgoods =false
          this.newgoods = JSON.parse(localStorage.getItem('curgoods'))
          that.edattrs = JSON.parse(localStorage.getItem('newgattrs'))
          that.edspec = JSON.parse(localStorage.getItem('newgspecs'))
          that.getlbtlist()
          that.pagecontext = localStorage.getItem('newgdes')
          window.console.log('当前商品',this.newgoods)
        } else {
          this.newgoods = ''
          that.edattrs = []
          that.edspec = []
          that.lbtdata = []
          that.pagecontext = ''
        }
      },
      nextattr (val) {
        that.curgoodsid = val
        that.activestep = 2
        that.gb_hidden = true
        that.ms_hidden = true
        that.ma_hidden = false
        that.img_hidden = true
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      prebaseinfo (val) {
        that.activestep = 1
        that.gb_hidden = false
        that.ma_hidden = true
        that.ms_hidden = true
        that.img_hidden = true
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      nextspec (val) {
        that.activestep = 3
        that.gb_hidden = true
        that.ma_hidden = true
        that.ms_hidden = false
        that.img_hidden = true
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      preattr () {
        that.activestep = 2
        that.gb_hidden = true
        that.ma_hidden = false
        that.ms_hidden = true
        that.img_hidden = true
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      nextimg () {
        that.activestep = 4
        that.gb_hidden = true
        that.ma_hidden = true
        that.ms_hidden = true
        that.img_hidden = false
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      preaspec () {
        that.activestep = 3
        that.gb_hidden = true
        that.ma_hidden = true
        that.ms_hidden = false
        that.img_hidden = true
        that.des_hidden = true
        localStorage.setItem('curstep', that.activestep)
      },
      preaimg () {
        that.activestep = 4
        that.gb_hidden = true
        that.ma_hidden = true
        that.ms_hidden = true
        that.des_hidden = true
        that.img_hidden = false
        localStorage.setItem('curstep', that.activestep)
      },
      nextdes () {
        that.activestep = 5
        that.gb_hidden = true
        that.ma_hidden = true
        that.ms_hidden = true
        that.img_hidden = true
        that.des_hidden = false
        localStorage.setItem('curstep', that.activestep)
      },
      completegoods () {
        that.activestep = 1
        localStorage.setItem('curstep', 6)
        localStorage.setItem('curgoodsid', -1)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/NewGoods.vue